import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import InvoiceModel from 'models/InvoiceModel';
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';
import SearchTransactionDto from 'models/SearchTransactionDto';

import { getAuthorizedApi, processAxiosError, urlBuilder } from "services/common.service";
import { setResultsDtoBase } from "reducers/dto.slice";


export const getInvoices = createAsyncThunk('invoices/getInvoices',
    async (searchDto: SearchTransactionDto, { dispatch }) => {
        try {

            const url = urlBuilder('/Invoices/GetInvoices', searchDto);

            const response = await getAuthorizedApi().get<ResultsDtoModel<InvoiceModel>>(url);
            const data = response.data;

            dispatch(setResultsDtoBase({
                totalResults: data.totalResults,
                offset: data.offset,
                page: data.page
            }));

            return data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
        }
        return initialResultsDtoModel;
    });

